import clsx from 'clsx';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { isWithinInterval } from 'date-fns';
import { DayType } from '../DatesCalendar.types';
import styles from './Day.css';

interface DayProps {
	day: DayType;
	onDayClick: (day: DayType) => void;
	testId: string;
}

const Day = ({ day, onDayClick, testId }: DayProps) => {
	const { datesRangeSel } = useFiltersContext();
	const [startSelection, endSelection] = datesRangeSel;

	function isWithinRangeSelection(dayCode: string): boolean {
		if (datesRangeSel.length !== 2) return false;
		return isWithinInterval(new Date(dayCode), { start: new Date(startSelection.code), end: new Date(endSelection.code) });
	}

	return (
		<button
			key={day.code}
			className={clsx(styles.root, {
				[styles.isWithinSelection]: isWithinRangeSelection(day.code),
				[styles.isDisabled]: day.isDisabled,
				[styles.startSelection]: day.code === startSelection?.code,
				[styles.endSelection]: day.code === endSelection?.code,
			})}
			data-date={`${day.code}T00:00:00.000Z`}
			onClick={() => onDayClick(day)}
			data-testid={testId}
		>
			{day.date}
		</button>
	);
};

export { Day };
